!function() {
  "use strict";

  class ZoomImages extends HTMLElement {
    constructor() {
      super();
      this.container = this.closest("[data-section-id]");
      this.images = this.querySelectorAll("[data-zoom-image]");
      this.videos = this.querySelectorAll("[data-zoom-video]");
      this.zoomCaptions = this.container.querySelector("[data-zoom-caption]");
      this.thumbsContainer = document.querySelector(".pswp__thumbs");
    }

    connectedCallback() {
      this.images.forEach((image, index) => {
        const zoomIndex = this.getZoomIndex(image);
        image.addEventListener("click", (e) => {
          e.preventDefault();
          if (!image.closest("product-images").classList.contains("is-dragging")) {
            this.createZoom(zoomIndex);
            window.a11y.lastElement = image;
          }
        });
        image.addEventListener("keyup", (e) => {
          if (e.code === "Enter") {
            e.preventDefault();
            this.createZoom(zoomIndex);
            window.a11y.lastElement = image;
          }
        });
      });

      this.videos.forEach((video, index) => {
        const zoomIndex = this.getZoomIndex(video);
        video.addEventListener("click", (e) => {
          e.preventDefault();
          if (!video.closest("product-images").classList.contains("is-dragging")) {
            this.createZoom(zoomIndex);
            window.a11y.lastElement = video;
          }
        });
        video.addEventListener("keyup", (e) => {
          if (e.code === "Enter") {
            e.preventDefault();
            this.createZoom(zoomIndex);
            window.a11y.lastElement = video;
          }
        });
      });
    }

    getZoomIndex(element) {
      const allZoomable = this.querySelectorAll("[data-zoom-image], [data-zoom-video]");
      return Array.from(allZoomable).indexOf(element);
    }

    createZoom(startIndex) {
      const thumbsTemplate = this.container.querySelector("[data-pswp-thumbs-template]")?.innerHTML;
      const allZoomable = this.querySelectorAll("[data-zoom-image], [data-zoom-video]");
      let items = [];
      let count = 0;

      allZoomable.forEach((element) => {
        count += 1;

        if (element.hasAttribute("data-zoom-image")) {
          const src = element.getAttribute("data-image-src");
          items.push({
            src: src,
            w: parseInt(element.getAttribute("data-image-width")),
            h: parseInt(element.getAttribute("data-image-height")),
            msrc: src
          });
        } else if (element.hasAttribute("data-zoom-video")) {
          const mediaType = element.getAttribute("data-media-type");
          const width = parseInt(element.getAttribute("data-video-width")) || 1920;
          const height = parseInt(element.getAttribute("data-video-height")) || 1080;
          const poster = element.getAttribute("data-poster");

          let html = '';

          if (mediaType === "video") {
            const videoUrl = element.getAttribute("data-video-url");
            html = `<div class="pswp__custom-content">
              <div class="pswp__video-wrapper">
                <video autoplay muted loop playsinline poster="${poster}">
                  <source src="${videoUrl}" type="video/mp4">
                </video>
              </div>
            </div>`;
          } else if (mediaType === "external_video") {
            const videoId = element.getAttribute("data-video-id");
            const videoHost = element.getAttribute("data-video-host");

            if (videoHost === "youtube") {
              html = `<div class="pswp__custom-content">
                <div class="pswp__video-wrapper pswp__video-wrapper--iframe">
                  <iframe src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&rel=0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen>
                  </iframe>
                </div>
              </div>`;
            } else if (videoHost === "vimeo") {
              html = `<div class="pswp__custom-content">
                <div class="pswp__video-wrapper pswp__video-wrapper--iframe">
                  <iframe src="https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowfullscreen>
                  </iframe>
                </div>
              </div>`;
            }
          }

          items.push({
            html: html,
            w: width,
            h: height,
            msrc: poster,
            isVideo: true
          });
        }

        if (allZoomable.length === count) {
          const colorScheme = this.getColorScheme();
          const options = {
            history: false,
            focus: false,
            index: startIndex,
            mainClass: `pswp-zoom-gallery${count === 1 ? " pswp-zoom-gallery--single" : ""}${colorScheme ? ` ${colorScheme}` : ""}`,
            showHideOpacity: true,
            showAnimationDuration: 150,
            hideAnimationDuration: 250,
            closeOnScroll: false,
            closeOnVerticalDrag: false,
            captionEl: true,
            closeEl: true,
            closeElClasses: ["caption-close", "title"],
            tapToClose: false,
            clickToCloseNonZoomable: false,
            maxSpreadZoom: 1,
            getDoubleTapZoom: function(isMouseClick, item) {
              if (item.isVideo) return 1;
              if (item.w >= 5000) return 0.2;
              if (item.w >= 3000) return 0.4;
              return 0.4;
            },
            loop: true,
            spacing: 0,
            allowPanToNext: true,
            pinchToClose: false,
            addCaptionHTMLFn: (item, captionEl, isFake) => {
              this.zoomCaption(item, captionEl, isFake);
            },
            getThumbBoundsFn: () => {
              const element = allZoomable[startIndex];
              const pageYScroll = window.scrollY || document.documentElement.scrollTop;
              const rect = element.getBoundingClientRect();
              return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
            }
          };

          if (this.thumbsContainer && thumbsTemplate !== "") {
            this.thumbsContainer.innerHTML = thumbsTemplate;
            const thumbs = this.thumbsContainer.querySelectorAll(".pswp__thumb");
            if (thumbs.length > 0 && thumbs[startIndex]) {
              thumbs[startIndex].classList.add("is-current");
              thumbs[startIndex].setAttribute("aria-current", "true");
            }
          }

          new window.theme.LoadPhotoswipe(items, options);
        }
      });
    }

    zoomCaption(item, captionEl) {
      let captionHtml = "";
      const captionContainer = captionEl.children[0];

      if (this.zoomCaptions) {
        captionHtml = this.zoomCaptions.innerHTML;
        if (this.zoomCaptions.closest(".variant--soldout")) {
          captionContainer.classList.add("variant--soldout");
        } else {
          captionContainer.classList.remove("variant--soldout");
        }
        if (this.zoomCaptions.closest(".variant--unavailable")) {
          captionContainer.classList.add("variant--unavailable");
        } else {
          captionContainer.classList.remove("variant--unavailable");
        }
      }

      captionContainer.innerHTML = captionHtml;
      return false;
    }

    getColorScheme() {
      const productInfo = this.closest("product-info");
      return Array.from(productInfo.classList).find(cls => cls.startsWith("color-scheme"));
    }
  }

  if (!customElements.get("zoom-images")) {
    customElements.define("zoom-images", ZoomImages);
  }
}();
